import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "../Text/Text";

interface PoweredByProps {
  type: "light" | "dark";
}

const PoweredByMezze: React.ReactFCWithChildren<PoweredByProps> = props => (
  <PoweredByWrapper {...props}>
    <Text>
      {"Powered by "}

      <a
        href="https://mezze.io"
        target="blank"
      >
        <img
          src="/assets/mezze_IQ_Black.png"
          alt="MezzeIQ"
        />
      </a>
    </Text>
  </PoweredByWrapper>
);

const PoweredByWrapper = styled.div<PoweredByProps>`
  ${({ type }) => css`
    background: ${type === "dark" ? "#1f1263" : ""};
    text-align: center;
    height: 25px;
    line-height: 25px;
    z-index: 1000;
    padding: 20px;
    display: flex;
    align-items: center;
    display: ${type === "dark" ? "none" : "block"};

    @media (min-width: 1024px) {
      display: block;
    }
    span, img {
      display: flex;
      align-items: center;
    }
    span {
      font-size: 10px;
      color: ${type === "dark" ? "#ffffff" : "inherit"};
      font-family: "Roboto";
      font-size: 15px;
      margin-left: 3px;

      a {
        color: ${type === "dark" ? "#ffffff" : "#1f1263"};
        text-decoration: underlines;
        font-family: "Roboto";

        img {
          height: 25px;
        }
      }
    }
  `}
`;

export default PoweredByMezze;
